import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initI18n } from './i18n/config';
import './styles.css';

/**
 * Điểm vào.
 *
 * i18next được khởi tạo TRƯỚC khi render: dựng cây React rồi mới nạp bản dịch
 * làm màn hình đầu tiên chớp qua một nhịp hiện toàn khóa i18n trần.
 */
async function bootstrap(): Promise<void> {
  await initI18n();

  const container = document.getElementById('root');
  if (!container) throw new Error('Thiếu phần tử #root trong index.html');

  createRoot(container).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

void bootstrap();
